<template>
  <v-dialog
    v-model="value"
    transition="dialog-top-transition"
    max-width="600px"
    persistent
  >
    <v-card>
      <v-toolbar
        color="primary"
        dark
        dense
      >{{hdrText}} единицы измерения </v-toolbar>
      <ref-m-u-card :mode="'editor'" :MU="localMU" @onMUUpdate="doMUUpdate"></ref-m-u-card>
      <v-card-actions>
        <v-btn class="secondary" @click="doClose">
          Отмена
        </v-btn>
        <v-spacer></v-spacer>
        <v-btn class="primary" dark outlined :disabled="saveDisabled" @click="doSave">
          {{btnText}}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { UI_SNACKBAR } from '@/store/actions/ui'
import axios from 'axios'
import RefMUCard from '@/components/modules/references/cards/refMUCard'

export default {
  name: 'refAddMUDialog',
  components: { RefMUCard },
  props: ['MU', 'value'],
  data () {
    return {
      localMU: null
    }
  },
  computed: {
    btnText: {
      get () {
        return this.localMU ? this.localMU.EI_ID ? 'Сохранить' : 'Создать' : ''
      }
    },
    hdrText: {
      get () {
        return this.localMU ? this.dataNew ? 'Добавление' : 'Редактирование' : 'Добавление'
      }
    },
    dataNew: {
      get: function () {
        return !this.localMU.EI_ID
      }
    },
    dataChanged: {
      get () {
        if (!this.MU) return false
        if (this.dataNew) return true
        return this.MU.EI_CODE !== this.localMU.EI_CODE || !this.localMU.OKEI || this.MU.OKEI.OKEI_ID !== this.localMU.OKEI.OKEI_ID
      }
    },
    saveDisabled: {
      get: function () {
        if (!this.localMU) return true
        const noName = !this.localMU.EI_NAME
        const noCode = !this.localMU.EI_CODE || this.localMU.EI_CODE.length < 5
        return noName || noCode || !this.dataChanged
      }
    },
    compID: {
      get: function () {
        return this.component ? this.component.COMP_ID : null
      }
    }
  },
  watch: {
    MU (val) {
      if (val) {
        // eslint-disable-next-line no-undef
        this.localMU = structuredClone(this.MU)
      } else {
        this.localMU = null
      }
    }
  },
  methods: {
    doSave () {
      const self = this
      const action = this.localMU.EI_ID ? 'update' : 'add'
      const processorPath = action === 'update' ? '/api/org/references/updMU.php' : '/api/org/references/addMU.php'
      const payload = { ...this.localMU }
      payload.MULTIPLIER = this.localMU.MULTIPLIER || 1
      payload.MULTIPLIER_INDICATOR = this.localMU.MULTIPLIER_INDICATOR || 1
      axios({
        url: processorPath,
        method: 'POST',
        data: payload
      })
        .then(resp => {
          if (resp.data.error === 'ok') {
            if (action === 'add') {
              self.$emit('MUAdded', [resp.data.data])
            } else {
              self.$emit('MUUpdate', [resp.data.data])
            }
          } else {
            self.$store.commit(UI_SNACKBAR, { color: 'red darken-1', text: `Ошибка: \n ${resp.data.error_text}` })
          }
        })
        .catch((err) => {
          self.$store.commit(UI_SNACKBAR, { color: 'red darken-1', text: `Ошибка: \n ${err}` })
        })
    },
    doClear () {
    },
    doClose () {
      this.doClear()
      this.$emit('input', false)
    },
    doMUUpdate (data) {
      console.log('refAddMUDualog:: doMUUpdate method called ', data)
      this.localMU = { ...this.localMU, ...data }
      console.log('refAddMUDualog:: doMUUpdate current data is ', this.localMU)
    }
  },
  mounted () {
    console.log('refAddMUDialog mounted with MU ', this.MU)
  }
}
</script>
